import { rem } from 'polished'
import styled from 'styled-components'

import { ItemMetadata } from 'tripPlanner/models'
import type { ItemType } from 'tripPlanner/types/tripItem'

interface Props {
  itemType: ItemType
}

const Placeholder = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${props => props.theme.palette.neutral.surface.lightBackground};
  width: 100%;
  height: ${rem(100)};
  overflow: hidden;
`

function PlaceholderImage({ itemType }: Props) {
  const Icon = ItemMetadata[itemType].icon
  return (
    <Placeholder>
      <Icon size={30} colour="light-foreground-alt" />
    </Placeholder>
  )
}

export default PlaceholderImage
